export default __webpack_public_path__ + "b03a8f9c9e25330aea11e58f16ab4d8a.png";